export default {
    //TODO: FIND BETTER PARAM NAMES
    deepCopy(oldObject, newObject){
        let keys = Object.getOwnPropertyNames(newObject);
        for (let i = 0; i < keys.length; i++) {
            let newObjectValue = newObject[keys[i]];
            if (typeof newObjectValue !== 'object') {
                oldObject[keys[i]] = newObjectValue;
            }
        }
    }
}